export default "__VITE_ASSET__COy_qBSl__"